import { GROUP_KEY } from 'api/Group/constants'
import type { Ranges } from 'api/System/types'
import type { SORT_ORDER } from 'constants.js'
import { getDateKey } from 'data/utils'
import { moment } from 'locale'
import type { Action } from 'redux'
import { CHANGE_DATA_SORTING } from 'revenue/constants'
import { DEFAULT_SORT_BY } from 'revenue/RevenueDetails/constants'
import type { RequestDate } from 'types/UI'
import { emptyObject, parseDateForRequest } from 'utils'

import { FETCH_STORES, FETCH_STORES_DONE, FETCH_STORES_ERROR, FETCH_STORES_SUCCESS } from './constants'
import type { RequestStoresType, StoreResponse, Stores } from './types'

interface ReducerAction extends Action {
  payload: {
    channel: string
    countryId: string
    data: StoreResponse[]
    dateCompared?: RequestDate | null
    dateCurrent: RequestDate
    errorCode?: number
    owner?: string
    range: Ranges
    saleType?: string
    sortBy: string
    sortOrder: SORT_ORDER
    storesType: RequestStoresType
  }
}

const defaultSort = {
  sortBy: DEFAULT_SORT_BY.value,
  sortOrder: DEFAULT_SORT_BY.order,
}

export default function stores(state: Stores = emptyObject, { payload, type }: ReducerAction) {
  const dataKey = getDateKey(payload || emptyObject)

  switch (type) {
    case FETCH_STORES:
      return {
        ...state,
        [dataKey]: {
          ...(state[dataKey] || emptyObject),
          errorCode: null,
          isLoading: true,
        },
      }
    case FETCH_STORES_DONE:
      return {
        ...state,
        [dataKey]: {
          ...(state[dataKey] || emptyObject),
          isLoading: false,
        },
      }
    case FETCH_STORES_ERROR:
      return {
        ...state,
        [dataKey]: {
          errorCode: payload?.errorCode,
          isLoading: false,
        },
      }
    case FETCH_STORES_SUCCESS:
      return {
        ...state,
        [dataKey]: {
          ...(state[dataKey] || emptyObject),
          ...defaultSort,
          data: {
            ...(state[dataKey]?.data || emptyObject),
            [payload.storesType]: payload.data,
          },
          fetchTime: parseDateForRequest(moment(), true),
          isLoading: false,
        },
      }
    case CHANGE_DATA_SORTING:
      return {
        ...state,
        [dataKey]: {
          ...(state[dataKey] || emptyObject),
          sortBy: payload.sortBy,
          sortOrder: payload.sortOrder,
        },
      }
    default:
      return state
  }
}
